module.exports = __webpack_public_path__ + "media/images/icons/badge-eabaf83ed44618782d874b1b7c363759.svg";